import { Component } from '@angular/core';
import { ProductSearchService, TranslationService } from '@spartacus/core';
import { switchMap } from 'rxjs';

@Component({
  selector: 'cx-qty-results',
  templateUrl: './plp-qty-results.component.html',
  styleUrl: './plp-qty-results.component.scss',
  standalone: false,
})
export class PlpQtyResultsComponent {
  qty$ = this.productSearchService.getResults().pipe(
    switchMap((results: any) => {
      const total = results?.pagination?.totalResults || 0;
      const currentPage = results?.pagination?.currentPage || 0;
      const pageSize = results?.pagination?.pageSize || 20;

      const start = currentPage * pageSize + 1;
      const end = Math.min((currentPage + 1) * pageSize, total);

      return this.translationService.translate('category.search.qtyLabel', { start, end, total });
    }),
  );

  constructor(
    private productSearchService: ProductSearchService,
    private translationService: TranslationService,
  ) {}
}
